/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon24Solid = forwardRef('ArrowFigureACircleLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm16 0a1 1 0 0 0-1-1H8.961l2.293-2.293A1 1 0 0 0 9.84 7.293l-3.006 3.006c-.94.94-.94 2.463 0 3.402l3.006 3.006a1 1 0 0 0 1.414-1.414L8.961 13H17a1 1 0 0 0 1-1Z" })));
});
